import { FILTER_QUERY_VALUE_TYPES } from '@frontend/api';

import { type SignalWithId } from './queryBuilding';

const UNIT_BEARING_VALUE_TYPES: readonly string[] = [
  FILTER_QUERY_VALUE_TYPES.DISTANCE,
  FILTER_QUERY_VALUE_TYPES.AREA,
  FILTER_QUERY_VALUE_TYPES.VOLUME,
  FILTER_QUERY_VALUE_TYPES.ROUGHNESS,
];

/**
 * Checks if a signal has any filters that carry units (dimensional or
 * roughness). Used to decide whether to surface the unit picker.
 */
export const hasUnitBearingFilters = (signal: SignalWithId): boolean => {
  return signal.groups.some((group) =>
    group.queries.some((query) =>
      UNIT_BEARING_VALUE_TYPES.includes(query.valueType),
    ),
  );
};
